<template>
  <b-form-group
    label="Adres"
    label-for="address"
  >
    <validation-provider
      #default="{ errors }"
      name="Adres"
      rules="required"
    >
      <b-form-textarea
        id="address"
        v-model="itemData.address"
        placeholder="Adres"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'AddressText',
  components: { ValidationProvider, BFormTextarea, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['branches/dataItem']
    },
  },
}
</script>
